<!--
 * @Description: 任务间隔时间、距离、年龄 内部数据直接使用parent
 * @Date: 2019-09-16 15:24:55
 -->
<template>
  <div>
    <el-form-item label="下一任务间隔时间：">
      <el-input
        placeholder=""
        v-model="parent.ruleForm[parent.sceneControlKey].intervalTime"
      >
        <span slot="suffix">分钟</span>
      </el-input>
      <span class="note-s1">
        注：当前任务结束时间与下个任务开始时间间隔（线下场景生效）
      </span>
    </el-form-item>
    <el-form-item label="任务定位距离：">
      <div
        class="distance"
        v-for="(item, index) in parent.ruleForm.riskBaseControlDistanceList"
        :key="index"
      >
        <span>任务间隔</span>
        <el-input
          placeholder=""
          style="margin:0 12px"
          v-model="item.minuteTime"
        >
          <span slot="suffix">分钟</span>
        </el-input>
        <span>内，用户移动距离不得超过</span>
        <el-input
          placeholder=""
          style="margin:0 30px 0 12px"
          v-model="item.distanceKilometre"
        >
          <span slot="suffix">公里</span>
        </el-input>
        <el-button
          type="text"
          :style="{ color: index ? '#F69208' : '#1989FA', fontSize: '18px' }"
          @click="addremove(item, index)"
        >
          <span>{{ index ? '-' : '+' }}</span>
          <span>{{ index ? '删除' : '新增' }}</span>
        </el-button>
      </div>
    </el-form-item>
    <el-form-item label="执行者年龄区间：">
      <div class="form-item-flex">
        <el-input
          placeholder=""
          v-model="parent.ruleForm[parent.sceneControlKey].ageStart"
        >
          <span slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input
          placeholder=""
          v-model="parent.ruleForm[parent.sceneControlKey].ageEnd"
        >
          <span slot="suffix">岁</span>
        </el-input>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  inject: ['parent'],
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    /**
     * @description: 距离新增删除
     * @param {object} item 当前数据
     * @param {number} index 当前index
     * @return: void
     */
    addremove(item, index) {
      if (index) {
        this.parent.ruleForm.riskBaseControlDistanceList.splice(index, 1);
      } else {
        this.parent.ruleForm.riskBaseControlDistanceList.push({
          minuteTime: '',
          distanceKilometre: ''
        });
      }
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
